import { render, staticRenderFns } from "./HistoryTwelve2.vue?vue&type=template&id=7c72aa4b&scoped=true"
import script from "./HistoryTwelve2.vue?vue&type=script&lang=js"
export * from "./HistoryTwelve2.vue?vue&type=script&lang=js"
import style0 from "./HistoryTwelve2.vue?vue&type=style&index=0&id=7c72aa4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72aa4b",
  null
  
)

export default component.exports